<template>
    <a-list-item-meta class="item-meta">
        <div slot="avatar" class="avatar-container">
            <user-link :name="post.author.name" :id="post.author.id">
                <a-avatar :src="post.author.avatar" shape="square" :size="app.mobile ? 40 : 72"/>
            </user-link>
            <user-link :name="post.author.name" :id="post.author.id"/>
        </div>
        <div slot="description" class="main">
            <div class="content">
                <p v-html="parse(post.content)" class="renderText"></p>
                <p class="bottom">
                    {{ post.fid }} 楼
                        | 发表于 {{ formatDate(post.posttime) }}
                    <span v-if="post.edittime > post.posttime">
                        | 最后编辑于 {{ formatDate(post.edittime) }}
                    </span>
                    <a-button v-if="post.fid != 1" type="link" @click="triggerWriteboard()">{{ open ? '收起回复' : '回复' }}</a-button>
                    <a-button v-if="userid == post.author.id" type="link" @click="editPost()">编辑</a-button>
                    <a-button v-if="userid == post.author.id" type="link" @click="deletePost()">删除</a-button>
                    <a-button class="admin-button" v-else-if="hasEditPrivilege" type="link" @click="deletePostByAdmin()">删除</a-button>
                    <a-dropdown v-if="post.fid == 1 && hasEditPrivilege" :trigger="['click']">
                        <a class="admin-button ant-dropdown-link" @click="e => e.preventDefault()">
                            管理<a-icon type="down" />
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item v-for="item of app.manageItems" :key="item.key">
                                <a href="javascript:;"
                                    @click="app.manageThread(item.key)"
                                >{{ item.text[app.thread[item.key]] }}</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </p>
            </div>
            <div v-if="post.replies.length > 0 || open">
                <a-list
                    bordered size="small"
                    class="subpost-list"
                    item-layout="horizontal"
                    :data-source="replies"
                    rowKey="id"
                >
                    <a-list-item slot="renderItem" slot-scope="reply">
                        <Subpost :reply="reply" @reply="openWriteboard"></Subpost>
                    </a-list-item>
                    <div class="expand-button" v-if="needPackup">
                        <a-divider>
                            <a-button type="link" @click="toggleExpand">{{ expand ? '折叠回复' : `展开回复(剩余${ post.replies.length - 5 }条)` }}</a-button>
                        </a-divider>
                    </div>
                    <div class="writeboard" v-if="open">
                        <a-textarea v-model="text" ref="writeboard" auto-size></a-textarea>
                        <div class="textbar">
                            <span class="counter" :class="{ warn: overflow }">{{ text.length }} / 140</span>
                            <a-button type="primary" size="small" @click="appendSubpost()"
                                :disabled="overflow" :loading="replying"
                            >发送</a-button>
                        </div>
                    </div>
                </a-list>
            </div>
        </div>
    </a-list-item-meta>
</template>

<script>
import UserLink from '@/components/UserLink.vue';
import Subpost from './Subpost.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData, formatTime, getReason } from '../../utils/utils';
import { checkPrivilege } from '../admin/privilege';

export default {
    props: {
        post: Object,
    },
    data: () => ({
        open: false,
        text: "",
        replyto: 0,
        replying: false,
        expand: false,
    }),
    inject: [ 'app' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        mobile() {
            return this._mobile;
        },
        overflow() {
            return this.text.length > 140;
        },
        replies() {
            return this.expand ? this.post.replies : this.post.replies.slice(0, 5);
        },
        needPackup() {
            return this.post.replies.length > 5;
        },
        hasEditPrivilege() {
            return checkPrivilege({ bbs: 1 }, this.userPrivilege);
        },
    },
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp, { day: '今天 HH:mm' });
        },
        /**
         * @param {string}raw
         */
        parse(raw, space = true) {
            if (!space)
                raw = raw.replace(/ /, "&nbsp;");
            return raw
                .replace(/\n<br>/g, "<br>")
                .replace(/[\n\r]/g, "<br>");
        },
        toggleExpand() {
            this.expand = !this.expand;
        },
        triggerWriteboard() {
            this.open = !this.open;
            if (this.open) {
                this.focusWriteboard();
            }
        },
        openWriteboard(reply) {
            this.open = true;
            if (reply) {
                this.replyto = reply.id;
                this.text = `回复 @${reply.author.name}: `;
            } else {
                this.text = '';
            }
            this.focusWriteboard();
        },
        focusWriteboard() {
            this.$nextTick(() => {
                this.$refs.writeboard.focus();
            })
        },
        manageThread() {
            this.$emit('manage');
        },
        async appendSubpost() {
            this.replying = true;
            const { post: { id: pid }, text: content, replyto } = this;
            try {
                const { data } = await axios
                    .post("/backend/bbs/appendSubpost.php", createFormData({
                        pid, content, client: 'web', replyto
                    }));
                this.replying = false;
                if (data.code == 0) {
                    this.$message.success('回复成功');
                    const post = this.app.data.find(e => e.id == pid);
                    post.replies = data.subposts;
                    this.text = "";
                    this.replyto = 0;
                    this.expand = true;
                } else {
                    const reason = getReason(data.code);
                    this.$message.error(`回复失败: ${ reason }`);
                }
            } catch (e) {
                this.$message.error(`回复失败, 错误: ${ e }`);
            } finally {
                this.replying = false;
            }
        },
        editPost() {
            this.$emit('edit', this.post);
        },
        async deletePost() {
            const { tid, id: pid, fid } = this.post;
            if (fid == 1) {
                this.$confirm({
                    title: '确认要删除帖子吗？',
                    content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                    onOk: async() => {
                        const { data } = await axios
                            .post("/backend/bbs/deleteThread.php", createFormData({
                                tid
                            }));
                        if (data.code == 0) {
                            this.$message.success('删除成功');
                            window.location.assign('/bbs');
                        } else {
                            this.$message.error('删除失败');
                        }
                    },
                    onCancel() {
                        //
                    },
                });
            } else {
                this.$confirm({
                    title: '确认要删除回帖吗？',
                    content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                    onOk: async() => {
                        const { data } = await axios
                            .post("/backend/bbs/deletePost.php", createFormData({
                                pid
                            }));
                        if (data.code == 0) {
                            this.$message.success('删除成功');
                            window.location.reload();
                        } else {
                            this.$message.error('删除失败');
                        }
                    },
                    onCancel() {
                        //
                    },
                });
            }
        },
        async deletePostByAdmin() {
            const { tid, id: pid, fid } = this.post;
            if (fid == 1) {
                const reason = prompt('确认要删除帖子吗？\n你正在动用管理权限，请给出删除理由', '');
                if (reason === null) return;
                const { data } = await axios
                    .post("/backend/bbs/deleteThread.php", createFormData({
                        tid, reason
                    }));
                if (data.code == 0) {
                    this.$message.success('删除成功');
                    window.location.assign('/bbs');
                } else {
                    this.$message.error('删除失败');
                }
            } else {
                const reason = prompt('确认要删除回帖吗？\n你正在动用管理权限，请给出删除理由', '');
                if (reason === null) return;
                const { data } = await axios
                    .post("/backend/bbs/deletePost.php", createFormData({
                        pid, reason
                    }));
                if (data.code == 0) {
                    this.$message.success('删除成功');
                    window.location.assign('/bbs');
                } else {
                    this.$message.error('删除失败');
                }
            }
        },
    },
    components: {
        UserLink, Subpost,
    }
}
</script>

<style lang="less" scoped>
.main {
    .content {
        min-height: 120px;
        display: flex;
        flex-direction: column;
        text-align: left;
    }
    .bottom {
        margin-top: auto;
        margin-bottom: -10px;
        text-align: right;
    }
    .ant-btn {
        span {
            margin: 0px;
        }
        padding: 0 6px;
    }
}
.subpost-list {
    margin-top: 10px;
}
.writeboard {
    margin: 10px 15px;
    .ant-input {
        margin-bottom: 5px;
    }
    .textbar {
        .counter {
            &.warn {
                color: red;
            }
            margin: 0 5px;
        }
        .ant-btn {
            span {
                margin: 0px 10px;
            }
        }
        text-align: right;
    }
}
.admin-button {
    color: grey;
}
</style>

<style lang="less">
.renderText {
    color: #444444;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
    overflow-wrap: anywhere;
}
.ant-list-item-meta {
    @media screen and (max-width: 599px) {
        flex-direction: column;
        margin: 0 5px;
        width: 100%;
        .ant-list-item-meta-avatar {
            width: 100%;
        }
    }
}
.avatar-container {
    display: flex;
    @media screen and (min-width: 600px) {
        flex-direction: column;
        width: 96px;
    }
    @media screen and (max-width: 599px) {
        width: 100%;
        .user-link {
            margin-left: 10px;
        }
    }
    align-items: center;
    margin-bottom: 5px;
}
.ant-list-item-meta-avatar {
    a {
        margin-top: 10px;
        font-size: 14px;
    }
}
.ant-list-item-meta-content {
    width: 100%;
}
.ant-modal-mask, .ant-modal-wrap {
    z-index: 10001 !important;
}
</style>
